import { render } from "./LoginGosuslugiView.vue?vue&type=template&id=51674fe4&scoped=true"
import script from "./LoginGosuslugiView.vue?vue&type=script&lang=js"
export * from "./LoginGosuslugiView.vue?vue&type=script&lang=js"

import "./LoginGosuslugiView.vue?vue&type=style&index=0&id=51674fe4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51674fe4"]])

export default __exports__